import { ErrorHandler, NumberValueWrapper, RequestOptions } from '../common/models/GenericTypes';
import { Get, Post, Put } from '../util/HttpUtils';
import { BillingGroup } from '../common/models/BillingGroup';
import { Contact } from '../common/models/Contacts';

export async function GetBillingGroupById(billingGroupId: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<BillingGroup>(`api/billing-groups/${billingGroupId}`, options);
}

export async function CreateBillingGroup(
  billingGroupData: Partial<BillingGroup>,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Post<NumberValueWrapper>('api/billing-groups', options, billingGroupData);
}

export async function UpdateBillingGroup(
  billingGroupId: number,
  billingGroupData: Partial<BillingGroup>,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Put<boolean>(`api/billing-groups/${billingGroupId}`, options, billingGroupData);
}

export async function GetBillingGroupAdditionalContacts(
  billingGroupId: number,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<Contact[]>(`api/billing-groups/${billingGroupId}/contacts`, options);
}

export async function UpdateAdditionalContacts(
  billingGroupId: number,
  contactIds: number[],
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
    noDataReturned: true,
  };

  return Put<boolean>(`api/billing-groups/${billingGroupId}/contacts`, options, contactIds);
}
